import { Component, OnInit, Input, SimpleChanges, OnChanges } from '@angular/core';
import { FormField } from '../../../models/form-field';
import { FormGroup } from '@angular/forms';


@Component({
  selector: 'app-dynamic-form-input',
  templateUrl: './dynamic-form-input.component.html',
  styleUrls: ['./dynamic-form-input.component.css']
})
export class DynamicFormInputComponent implements OnInit
{
  opcion: any;
  select: any;

  constructor() { }

  ngOnInit(): void
  {    
    if (this.input.controlType == "dropdown") 
    {
      this.select = this.input.value;
    }
  }

  @Input() input: FormField<string>;
  @Input() form: FormGroup;

  get isValid() { return this.form.controls[this.input.key].valid; }

  onChange(event, id)
  {
    if (event.value == null)
    {
      this.form.controls[id].setValue("");
      if (id = "LEGAJOS_DD") {
        this.form.controls["LEGAJOS_HH"].setValue("");
      }
    } else
    {
      this.form.controls[id].setValue(event.value.id);
      if (id == "LEGAJOS_DD") {
        let hasta = this.form.controls["LEGAJOS_HH"].value;
        if (hasta == "")
        {
          this.form.controls["LEGAJOS_HH"].setValue(event.value.id);
        }
      }
    }
    
  }
}
